import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpContentContainer, DtpNoContent } from 'dtp-react-components';
import {
  Table,
} from '../../components/index';
import {
  doGet,
} from '../../utils/requests';
import * as listUtils from '../../utils/listsSelect';
import * as constantes from '../../utils/constants';
import FiltroPesquisa from './FiltroPesquisa';
import { manterApenasFiltro } from '../../utils/helpers';
import RelatorioFilaPrisma from './exportacao-csv/RelatorioFilaPrisma';

class ConsultaPrisma extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaRegistrosFiltrada: null,
      listaRegistrosIndexada: [],
      registroVindoDoRequest: null,
      showNoContent: false,
      listaRegistrosIndexadaAtualizada: false,
      estadoTabela: {
        quantidadeTotalResultados: 0,
        resultadosPorPagina: 10,
        paginaAtual: 1,
      },
      filtrosPesquisa: {},
    };
  }

  componentDidMount() {
    manterApenasFiltro('');
  }

  componentDidUpdate(prevProps) {
    // Apenas repete consulta se parametro da url for alterado
    if (this.props.match.params.tipoConsulta !== prevProps.match.params.tipoConsulta) {
      this.preparaNovaConsulta();
    }
  }

  getTipoConsulta = () => (
    this.props.match.params.tipoConsulta
  )

  preparaNovaConsulta = () => {
    const estadoTabela = {
      quantidadeTotalResultados: 0,
      resultadosPorPagina: 10,
      paginaAtual: 1,
    };
    this.setState({
      listaRequerimentosFiltrada: null,
      estadoTabela,
    }, this.realizaConsulta());
  }

  lotacao = this.props.auth.userData.lotacoes[0];

  realizaConsulta = (filtrosPesquisa) => {
    // params estados[]: int , cpf : string,
    // tipoRequerimento: 1 || 2, participacao: 1 || 2, atributoOrdenacao: string
    let filtrosConsulta = {};
    if (filtrosPesquisa) {
      filtrosConsulta = this.montaFiltros(filtrosPesquisa);
    }

    filtrosConsulta['tipo-consulta'] = this.getTipoConsulta();

    // Copiar atributos além do filtro
    const atributosConsulta = this.verificaAtributosParaConsulta();
    if (atributosConsulta) {
      if (filtrosConsulta.estado === undefined) {
        filtrosConsulta.estado = atributosConsulta.estados;
      }
      filtrosConsulta.participacao = atributosConsulta.tipoParticipacao;
      filtrosConsulta['atributo-ordenacao'] = atributosConsulta.campoOrdenacao;
      if (atributosConsulta.filtroTipoExigencias) {
        filtrosConsulta['tipo-exigencia'] = atributosConsulta.filtroTipoExigencias;
      }
    }
    this.setState({ ...this.state, filtrosConsulta }, this.executaConsulta);
  }

  executaConsulta = () => {
    if (Object.entries(this.state.filtrosConsulta).length !== 0) {
      const { resultadosPorPagina } = { ...this.state.estadoTabela };
      const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
      doGet(
        'beneficios-prisma',
        this.tratarSucesso,
        this.tratarErro,
        {
          ...this.state.filtrosConsulta,
          filtro: this.state.filtrosConsulta.filtro,
          'start-position': primeiroItem,
          'max-results': resultadosPorPagina,
        },
      );
    } else {
      this.setState({ listaRegistrosIndexada: [], listaRegistrosIndexadaAtualizada: true });
    }
  }

  montaFiltros = (atributosPesquisa) => {
    let atributos = {};
    // filtro é a caixa de texto que pesquisa por cpf, nit e nb
    let filtroValido = atributosPesquisa.filtro;
    if (filtroValido === null) {
      filtroValido = '';
    }
    atributos = { ...atributos, filtro: filtroValido };

    if (atributosPesquisa.dtPrismaInicio) {
      atributos = { ...atributos, dtPrismaInicio: atributosPesquisa.dtPrismaInicio };
    }
    if (atributosPesquisa.dtPrismaFim) {
      atributos = { ...atributos, dtPrismaFim: atributosPesquisa.dtPrismaFim };
    }
    if (atributosPesquisa.dtComprevInicio) {
      atributos = { ...atributos, dtComprevInicio: atributosPesquisa.dtComprevInicio };
    }
    if (atributosPesquisa.dtComprevFim) {
      atributos = { ...atributos, dtComprevFim: atributosPesquisa.dtComprevFim };
    }
    if (atributosPesquisa.especieBeneficio) {
      atributos = { ...atributos, especieBeneficio: atributosPesquisa.especieBeneficio };
    }

    const { resultadosPorPagina } = { ...this.state.estadoTabela };
    if (atributosPesquisa.cliqueiNoBotao === 1) {
      this.state.estadoTabela.paginaAtual = 1;
    }
    const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
    atributos = { ...atributos, 'max-results': resultadosPorPagina };
    atributos = { ...atributos, 'start-position': primeiroItem };

    return atributos;
  }

  verificaAtributosParaConsulta = () => {
    if (this.getTipoConsulta()) {
      return constantes.estadosParaConsulta[this.getTipoConsulta()];
    }
    return null;
  }

  tratarSucesso = (response) => {
    let quantidadeTotalResultados = 0;
    if (response.headers['content-range']) {
      const { headers } = { ...response };
      // eslint-disable-next-line
      quantidadeTotalResultados = headers['content-range'].split('/')[1];
    }
    const { estadoTabela } = { ...this.state };
    estadoTabela.quantidadeTotalResultados = quantidadeTotalResultados;
    if (response.data === '') {
      this.setState({
        showNoContent: false,
        listaRegistrosIndexada: [],
        listaRegistrosIndexadaAtualizada: true,
        estadoTabela,
      });
    } else {
      this.setState({
        showNoContent: false,
        listaRegistrosIndexada: response.data,
        listaRegistrosIndexadaAtualizada: true,
        estadoTabela,
      });
    }
  };

  /**
   * Trata filtros na lista que veio do servidor (Componente FiltroPesquisa)
   */
  tratarFiltroNaLista = (listaRegistrosFiltrada) => {
    this.setState({ listaRegistrosFiltrada, listaRegistrosIndexadaAtualizada: false });
  }

  tratarErro = (error) => {
    if (error) {
      const { data } = { ...error };
      if (error.status) {
        if (error.status === 404) {
          this.setState({
            showNoContent: true,
            noContentPrimaryMessage: 'Requerimento não encontrado para o protocolo informado.',
            noContentSecondaryMessage: 'Informe um protocolo válido.',
          });
        } else {
          this.setState({
            showNoContent: true,
            noContentPrimaryMessage: `${data.mensagem}`,
            noContentSecondaryMessage: `${data.descricao}`,
          });
        }
      } else {
        this.setState({
          showNoContent: true,
          noContentPrimaryMessage: 'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',
          noContentSecondaryMessage: 'Tente novamente mais tarde.',
        });
      }
    }
  }

  handleChange = (e, name) => {
    this.setState({
      ...this.state,
      [name]: e,
    });
  }

  addTipoRequerimentoLabel = tipo => (
    listUtils.getObject(listUtils.tipoRequerimento, tipo).label
  )

  addTipoEstadoLabel = (tipo) => {
    if (tipo === 15) {
      return 'Exigência/indeferido';
    }

    if (tipo === 16) {
      return 'Indeferimento ratificado';
    }

    return listUtils.getObject(listUtils.tiposEstado, tipo).label;
  }

  colunasDefault = [
    {
      id: 'cpf',
      label: 'CPF',
    }, {
      id: 'especie',
      label: 'Espécie',
    }, {
      id: 'motivoPrisma',
      label: 'motivo PRISMA',
    }, {
      id: 'dtRecibementoPrisma',
      label: 'Data de Recebimento PRISMA',
    }, {
      id: 'dtEnvioComprev',
      label: 'Data de Envio COMPREV',
    }, {
      id: 'nb',
      label: 'Número do Benefício',
    }, {
      id: 'resultado',
      label: 'Resultado',
    }];

  montaColunas = () => {
    const requerimentosExigenciaTableHeader = this.colunasDefault.slice();
    return requerimentosExigenciaTableHeader;
  }

  defineListaParaTabela = () => {
    if (this.state.listaRegistrosFiltrada !== null) {
      return this.state.listaRegistrosFiltrada;
    }
    return this.state.listaRegistrosIndexada;
  }

  alterarPagina = (pagina, page) => {
    const { estadoTabela } = { ...this.state };
    if (pagina === 0) {
      estadoTabela.paginaAtual = 1;
    } else {
      estadoTabela.paginaAtual = pagina;
    }

    if (page) {
      estadoTabela.resultadosPorPagina = page;
    }

    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }

  alterarResultadosPorPagina = (resultadosPorPagina) => {
    const { estadoTabela } = { ...this.state };
    estadoTabela.resultadosPorPagina = resultadosPorPagina;
    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }

  render() {
    const options = {
      noDataText: 'Nenhum requerimento a ser exibido',
      hideSizePerPage: false,
      onPageChange: this.alterarPagina,
      page: this.state.estadoTabela.paginaAtual,
      sizePerPage: this.state.estadoTabela.resultadosPorPagina,
      sizePerPageList: listUtils.linhasPorPagina,
    };
    const fetchInfo = {
      dataTotalSize: this.state.estadoTabela.quantidadeTotalResultados,
    };
    const requerimentosExigenciaTableHeader = this.montaColunas();

    return (
      this.state.showNoContent ? (
        <DtpNoContent
          primarylabel={this.state.noContentPrimaryMessage}
          secondarylabel={this.state.noContentSecondaryMessage}
          show={this.state.showNoContent}
        />
      ) : (
        <DtpContentContainer>
          <FiltroPesquisa
            handleSearchFilter={this.realizaConsulta}
            handleChangeList={this.tratarFiltroNaLista}
            destinatarios=""
            list={this.state.listaRegistrosIndexada}
            tipoConsulta={this.getTipoConsulta()}
            listaRegistrosIndexadaAtualizada={this.state.listaRegistrosIndexadaAtualizada}
          />
          {((this.state.listaRegistrosIndexada) && (this.state.listaRegistrosIndexada.length > 0)) ?
            <RelatorioFilaPrisma filtrosConsulta={this.state.filtrosConsulta} />
          : '' }
          <Table
            legend={this.state.estadoTabela.quantidadeTotalResultados === 0 ? 'Consulta PRISMA' :
            `Consulta PRISMA -  ${this.state.estadoTabela.quantidadeTotalResultados} registro(s) encontrado(s)`}
            bordered
            fetchInfo={fetchInfo}
            data={this.defineListaParaTabela()}
            options={options}
            listaTableHeader={requerimentosExigenciaTableHeader}
            pagination
            remote
          />
        </DtpContentContainer>
      )
    );
  }
}

ConsultaPrisma.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      protocolo: PropTypes.string,
      tipoConsulta: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }).isRequired,
};

ConsultaPrisma.defaultProps = {
  match: null,
};

export default ConsultaPrisma;



// WEBPACK FOOTER //
// ./src/pages/consultas/ConsultaPrisma.jsx